<template>
  <div>
    <van-tabs v-model="activeName" sticky animated @click="onClick">
      <template v-for="TemplateEle in list">
        <van-tab
          v-for="ele in TemplateEle.children"
          :key="ele.id"
          :title="ele.name"
          :name="ele.id"
          rel="tabWidth"
        >
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <!-- 下拉刷新 -->
            <van-list
              v-model="loading"
              :finished="finished"
              loading-text="正在加载中..."
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              finished-text="我是有底线的哦 ~ "
              @load="onLoad"
            >
              <!-- 上拉加载 -->
              <div
                class="comntmarginTop"
                style="display: flex; justify-content: flex-start; flex-wrap:wrap; align-items:stretch;"
              >
                <dl
                  class="comntDl"
                  v-for="(ele,index) in dataList"
                  :key="index"
                  @click="goHome(ele)"
                >
                  <dt>
                    <van-image :src="ele.pic">
                      <template v-slot:error>加载失败</template>
                    </van-image>
                  </dt>
                  <dd>
                    <p class="ellpis">
                      <span v-if="ele.supplierCode=='ZY'" class="ZY">自营</span>
                      <span v-else-if="ele.houniaoAbroadStatus ===1" class="houniaoAbroadStatus">海外</span>
                      <span
                        v-if="ele.supplierCode=='ZY'"
                        :class="ele.supplierCode=='ZY'?'Name ':''"
                      >{{ele.name}}</span>
                      <span
                        v-else-if="ele.houniaoAbroadStatus ===1"
                        :class="ele.houniaoAbroadStatus==1?'Name ':''"
                      >{{ele.name}}</span>
                      <span v-else>{{ele.name}}</span>
                    </p>
                    <p>
                      <span class="EleName">￥{{ele.price}}</span>
                      <s class="EleOriginalPrice">￥{{ele.originalPrice}}</s>
                    </p>
                  </dd>
                </dl>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </template>
    </van-tabs>
  </div>
</template>
<script>
import { Tab, Tabs, List, PullRefresh, Image } from 'vant'
import { productList, Categorization } from '../../request/api.js'
export default {
  components: {
    [Image.name]: Image,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data () {
    return {
      activeName: 'a',
      list: [],
      error: false,
      dataList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1, // 页码
      offset: 100 // 滚动条与底部距离小于 offset 时触发load事件
    }
  },
  methods: {
    // 具体商品
    productListCode () {
      const params = {
        productCategoryId: this.$route.query.Roll,
        order: 1,
        pageSize: 12,
        pageNum: this.pageNum
      }
      console.log(params)
      productList(params)
        .then(res => {
          console.log(res)
          this.dataList = res.data.list
        })
        .catch(res => {
          console.log(res)
        })
    },
    // title头设置
    productCategoryTwoThree () {
      const params = {
        product_category_id: this.$route.query.ID
      }
      Categorization(params)
        .then(res => {
          console.log(res)
          this.list = res.data[0].children
          console.log(this.list)
        })
        .catch(res => {
          console.log(res)
        })
    },
    onLoad () {
      this.pageNum += 1
      const params = {
        productCategoryId: this.$route.query.Roll,
        order: 1,
        pageSize: 10,
        pageNum: this.pageNum
      }
      console.log(params)
      productList(params)
        .then(res => {
          if (res.code === 200) {
            setTimeout(() => {
              this.dataList = this.dataList.concat(res.data.list)
              this.loading = false
              if (this.dataList.length >= res.data.total) {
                this.finished = true
                console.log('到底了')
              }
            }, 1000)
          } else {
            this.error = true
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    onRefresh () {
      setTimeout(() => {
        console.log('下拉刷新')
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    goHome (ele) {
      this.$router.push({ path: '/CommodityDetails', query: { id: ele.id, skuId: ele.defaultSkuId } })

      // this.$router.push(`/CommodityDetails/${ele.id}`)
    },
    onClick (name, title) {
      // console.log(name, title)
      // 具体商品
      const params = {
        productCategoryId: name,
        order: 1,
        pageSize: 12,
        pageNum: this.pageNum
      }
      console.log(params)
      productList(params)
        .then(res => {
          console.log(res)
          this.dataList = res.data.list
        })
        .catch(res => {
          // console.log(res)
        })
    }
  },
  created () {
    console.log(this.$route.query.Roll)
    this.activeName = this.$route.query.Roll
    console.log(this.activeName)
    this.productListCode()
    this.productCategoryTwoThree()
    // console.log(this.$route.query)
  },
  updated () {
    // console.log(document.getElementsByClassName('van-tab'))
    // console.log(document.getElementsByClassName('van-tabs__line')[0].style.width)
    // console.log(document.getElementsByClassName('van-tab')[0].textContent)
    // console.log(document.getElementsByClassName('van-tab__text'))
    var tabArr = document.getElementsByClassName('van-tab')
    var tabArrText = document.getElementsByClassName('van-tab__text')
    for (var i = 0; i < tabArrText.length - 1; i++) {
      // console.log(tabArrText[i])
      // console.log(tabArrText[i].clientWidth)
      // console.log(tabArr[i])
      // console.log(tabArr[i].clientWidth)
      if (tabArrText[i].clientWidth > tabArr[i].clientWidth) {
        tabArr[i].style.flexBasis = 'auto'
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-sticky {
  height: 90px;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  height: 90px;
  border: 0.2px solid #f2f2f2; /*no*/
  border-bottom: 1px solid #f2f2f2; /*no*/
}
/deep/ .van-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
// /deep/ .van-tabs__track {
//   transform: none !important;
// }
.Name {
  padding-left: 12px;
}
.EleName {
  color: #333333;
  font-size: 32px;
  font-weight: bold;
  padding-right: 15px;
}
.EleOriginalPrice {
  color: #999999;
  font-size: 28px;
}
.comntmarginTop {
  padding-left: 30px;
}
.comntmarginTop dl:nth-child(odd) {
  //所有奇数
  margin-right: 18px;
}
.comntDl {
  width: 336px;
  border-radius: 4px 4px 0px 0px;
  dt {
    width: 100%;
    height: 336px;
    .van-image {
      width: 100%;
      height: 100%;
    }
  }
  dd {
    height: 120px;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
  }
}
.ZY {
  color: white;
  padding: 2px 12px;
  font-size: 24px;
  border-radius: 5px;
  background-color: #E33F36;
}
//多行文本溢出隐藏
.ellpis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.houniaoAbroadStatus {
  color: #E33F36;
  padding: 1px 12px;
  font-size: 24px;
  border-radius: 5px;
  border: 1px solid #E33F36; /*no*/
}
/deep/.van-tabs__line {
  background-color: #E33F36;
  width: 60px;
}
</style>
